
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/iot-and-digital-eng",
      function () {
        return require("private-next-pages/services/iot-and-digital-eng.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/iot-and-digital-eng"])
      });
    }
  